<template>
  <div id="app">

      <div class="foot-text">
      Copyright © 2020 好运吧 深圳市无间数码科技有限公司
      <br />广东省深圳市福田区福田街道福山社区滨河大道5010号国际村3栋1单元
      <br />粤ICP备20010857号-2
      <br />
      <div class="contact-info-div">
        <div class="contact-info-div-image">
          <img src="/static/img/contact_phone@2x.png" alt="" srcset="">
        </div>
        <!--span>177-2754-5939</span-->
        <span>130-041-08059</span>
        
        <div class="contact-info-div-image">
          <img src="/static/img/contact_wx@2x.png" alt="" srcset="">
        </div>
        <span>haoyunbakefu</span>
      </div>
      <br />
      <br />
      <br />
    </div>
        <div @click="changeMenu" class="foot">立即注册</div>

  </div>
</template>
<script>
 export default {
  // metaInfo: {
  //   title: "好运吧"
  // },
  name: "app",
  data() {
    return {
      msg: "注册协议"
    };
  },
  methods: {
    changeMenu(){
      var cid = localStorage.getItem("cid");
      if(cid){
			  localStorage.setItem('cid',cid)
			  window.location='http://wap.haoyunba.com/#/indexLoad?cid='+cid
		  }else{
		  	window.location='http://wap.haoyunba.com/#/indexLoad?cid=G00001'
		  }
    
      
    } 
  },
   mounted: function() {

    this.$point.init(new Date());
  },
  components: {
    
  }
};
</script>
<style  scoped>

.foot {
  width: 750px;
  height: 120px;
  background: linear-gradient(0deg, #3189ff 0%, #0062e7 100%);
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 120px;
  bottom:0; 
	left:0;
  text-align:center; 
	z-index:999; 
	position:fixed; 
	bottom:0; 
	left:0;
}

.foot-text {
  width: 630px;
  height: 120x;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ababab;
  line-height: 30px;
  margin: 19px auto 170px auto;
}
.contact-info-div{
  padding-top: 30px;
  padding-bottom: 20px;
  align-items: center;
  justify-content: center;
  width: 480px;
  height: 40px;
  display: inline-table;
  vertical-align:middle;
  text-align:center;
  margin: 0 auto;
}

.contact-info-div span{
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color:   #343434;
  line-height: 0px;
  padding:0px;
  margin: 0 auto;
  vertical-align: middle;
  text-align:center;
  display:table-cell;
 
  margin: 0 auto;

}

.contact-info-div-image{
  width: 32px;
  height: 32px;
  padding-right: 0px;
  padding-left: 8px;
  float: left;
  display: inline-table;

}
.contact-info-div-image img{
  width: 100%;
  height: 100%;
 
}
</style>


// WEBPACK FOOTER //
// src/views/common/foot.vue